import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow-right\"><defs><style type=\"text/css\"></style></defs><path d=\"M343.4496 957.8496a51.2 51.2 0 0 1-78.336-65.3312l5.8368-7.168L644.4032 512 270.9504 138.6496A51.2 51.2 0 0 1 265.216 73.3184l5.8368-7.168A51.2 51.2 0 0 1 336.2816 60.416l7.168 5.8368 409.6 409.6a51.2 51.2 0 0 1 5.8368 65.3312l-5.8368 7.168-409.6 409.6z\" fill=\"#999999\" p-id=\"3092\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol